import { GoogleOAuthPage } from '@features/auth/components/GoogleOAuthPage';
import { OAuthCallbackSearchSchema } from '@routes/searchSchemas';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/googleoauth')({
  validateSearch: OAuthCallbackSearchSchema,
  component: GoogleOAuthPage,
});
